import React from 'react';
import Popconfirm from 'antd/es/popconfirm';
import { ConfigContext } from '../config-provider';
import AntdConfigProvider from 'antd/es/config-provider';
// export default withConfigProvider(Popconfirm);
const BdPopconfirm = React.forwardRef((props, ref) => {
    const { prefixCls } = props;
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('divider', prefixCls);
    return (React.createElement(AntdConfigProvider, { prefixCls: getPrefixCls('', prefixCls), ...restContext },
        React.createElement(Popconfirm, { ...props, ref: ref })));
});
export default BdPopconfirm;
